import { render, staticRenderFns } from "./ModifyCx3PackageModal.vue?vue&type=template&id=3561bb6a&"
import script from "./ModifyCx3PackageModal.vue?vue&type=script&lang=js&"
export * from "./ModifyCx3PackageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports